import React from "react";
import { ActionMenu } from "../shared/ActionMenu";

const StockPricesTable = ({ currentItems, handleUpdateClick, handleDelete }) => (
    <div className="relative w-full overflow-auto rounded-md border">
            <table className="w-full caption-bottom text-sm">
                <thead className="[&_tr]:border-b bg-muted/50">
                    <tr>
                        <th className="h-12 px-4 text-left align-middle font-medium text-muted-foreground">Date</th>
                        <th className="h-12 px-4 text-left align-middle font-medium text-muted-foreground">Prix d'ouverture</th>
                        <th className="h-12 px-4 text-left align-middle font-medium text-muted-foreground">Prix de clôture</th>
                        <th className="h-12 px-4 text-left align-middle font-medium text-muted-foreground">Prix le plus haut</th>
                        <th className="h-12 px-4 text-left align-middle font-medium text-muted-foreground">Prix le plus bas</th>
                        <th className="h-12 px-4 text-left align-middle font-medium text-muted-foreground">Volume</th>
                        <th className="h-12 px-4 text-left align-middle font-medium text-muted-foreground">Symbole</th>
                        <th className="h-12 px-4 text-right align-middle font-medium text-muted-foreground">Actions</th>
                    </tr>
                </thead>
                <tbody className="[&_tr:last-child]:border-0">
                    {currentItems.map((price) => (
                        <tr key={`${price.fk_stock_symbol}-${price.price_date}`} className="border-b transition-colors hover:bg-muted/50">
                            <td className="p-4 align-middle">
                                {new Date(price.price_date * 1000).toLocaleDateString('fr-FR')}
                            </td>
                            <td className="p-4 align-middle">{price.open_price}</td>
                            <td className="p-4 align-middle">{price.close_price}</td>
                            <td className="p-4 align-middle">{price.high_price}</td>
                            <td className="p-4 align-middle">{price.low_price}</td>
                            <td className="p-4 align-middle">{price.volume}</td>
                            <td className="p-4 align-middle">{price.fk_stock_symbol}</td>
                            <td className="p-4 align-middle text-right">
                                <ActionMenu
                                    onEdit={() => handleUpdateClick(price)}
                                    onDelete={() => handleDelete(price.price_date, price.fk_stock_symbol)}
                                />
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
);

export default StockPricesTable;
